import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReview: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="review,star-square"><path d="M12 8L13.1756 10.382L15.8042 10.7639L13.9021 12.618L14.3511 15.2361L12 14L9.64886 15.2361L10.0979 12.618L8.19577 10.7639L10.8244 10.382L12 8Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconReview;
